import { gql } from '@apollo/client';

export const CHAT_WITH_GUIDED_BOT = gql`
  mutation ChatWithGuidedBot($params: ChatWithGuidedBotInput) {
    chatWithGuidedBot(params: $params) {
      success
      message
      errors
      data {
        chatId
        botResponse {
          message
          inputType
          options
          skippable
          skipLabel
          searchEnabled
          canGoBack
          canRestart
          currentPath
        }
      }
    }
  }
`;

export const DELETE_GUIDED_CHAT = gql`
  mutation DeleteChatbotChat($params: DeleteChatbotChatInput!) {
    deleteChatbotChat(params: $params) {
      success
      message
      errors
    }
  }
`;
